<template>
  <CardItem
      :show-content="isCurrent"
      :options="options"
      v-on="$listeners"
  >
    <TextQuestion class="text-left">
      <TextCollapsed
          :title="question.text"
          :max-length="question.imageSrc ? 100 : 300"
      />
    </TextQuestion>
    <div class="flex-grow">
      <a-slider
          v-model="value"
          :min="0"
          :max="scoreScale"
          :marks="marks"
          :step="1"
          :style="{'--accent-color': accentColor.color, '--text-color': textColor.color}"
      />
      <div class="space-x-2 xs:space-x-4">
        <TextHelp v-if="showMinLabel" class="float-left">{{ minLabel }}</TextHelp>
        <TextHelp v-if="showMaxLabel" class="float-right">{{ maxLabel }}</TextHelp>
      </div>
    </div>
    <template #button>
      <a-button
          type="primary"
          size="large"
          class="btn-action-primary"
          :style="[buttonBgColor, buttonTextColor]"
          @click="onNext"
      >
        {{
          question.options.btnLabel || survey.translations.questions.open.buttonSubmit.value || survey.translations.questions.open.buttonSubmit.defaultValue
        }}
      </a-button>
    </template>
  </CardItem>
</template>

<script>
import {questionMixin, questionEventListenerMixin} from "@/mixins/question";
import {mapGetters} from "vuex";
import themeMixin from "../../mixins/theme.mixin";
import CardItem from "../CardItem";
import TextCollapsed from "../TextCollapsed";
import {Slider} from "ant-design-vue";
import TextQuestion from "../TextQuestion";
import TextHelp from "../TextHelp";

export default {
  name: "QuestionNps",
  props: {
    isCurrent: {
      type: Boolean,
      default: false
    },
    options: {
      type: Object,
      default: () => ({})
    },
  },
  components: {'a-slider': Slider, CardItem, TextCollapsed, TextQuestion, TextHelp},
  mixins: [questionMixin, questionEventListenerMixin, themeMixin],
  data() {
    return {
      value: 0,
    }
  },
  computed: {
    ...mapGetters(["survey"]),
    scoreScale: function () {
      return this.question.options.scoreScale;
    },
    marks: function () {
      let marks = {};
      for (let i = 0; i <= this.scoreScale; i++) {
        marks[i] = i;
      }
      return marks;
    },
    minLabel: function () {
      return this.question.translations.minLabel.value || this.survey.translations.questions.nps.minLabel.value || this.survey.translations.questions.nps.minLabel.defaultValue;
    },
    maxLabel: function () {
      return this.question.translations.maxLabel.value || this.survey.translations.questions.nps.maxLabel.value || this.survey.translations.questions.nps.maxLabel.defaultValue;
    },
    showMinLabel: function () {
      return this.question.translations.minLabel.active
    },
    showMaxLabel: function () {
      return this.question.translations.maxLabel.active
    },
  },
  methods: {
    onNext() {
      this.onAnswer(this.value);
    },
    onKeyDown(e) {
      if (!this.isCurrent) return;

      let value = parseInt(e.code.substring(e.code.length - 1));

      if (value >= 0 && value <= this.scoreScale) {
        this.value = value;
        this.onNext();
      } else if (e.key === '-' && this.scoreScale === 10) {
        this.value = 10;
        this.onNext();
      } else if (e.key === 'Enter') {
        this.onNext();
      }
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .ant-slider-track,
/deep/ .ant-slider:hover .ant-slider-track {
  background-color: var(--accent-color);
}

/deep/ .ant-slider-dot-active,
/deep/ .ant-slider-handle,
/deep/ .ant-slider:hover .ant-slider-handle:not(.ant-tooltip-open),
/deep/ .ant-slider-handle.ant-tooltip-open,
/deep/ .ant-slider-handle:focus {
  border-color: var(--accent-color);
}

/deep/ .ant-slider-handle {
  width: 20px;
  height: 20px;
  margin-top: -8px;
}

/deep/ .ant-slider-with-marks {
  margin-bottom: 36px;
  margin-top: 0;
}

/deep/ .ant-slider-mark {
  top: 16px;
}

/deep/ .ant-slider-handle:focus {
  outline: none;
  box-shadow: none;
}

/deep/ .ant-slider-mark-text-active,
/deep/ .ant-slider-mark-text {
  color: var(--text-color);
}
</style>
